import { EntityMessage } from "../../entity/EntityMessage";

export class DtoMessagesDeleteRes extends EntityMessage {
  public message: string | null = null;
}
